export const ALL = 'all'
export const SUCCESSFUL = 'successful'
export const FAILED = 'failed'
export const OTHER = 'other'
